import { Stack, Button, styled } from '@/theme/index';

export const ArticleContainer = styled(Button)({
  textAlign: 'left',
  border: 'none',
  margin: 0,
  color: 'inherit',
  ':hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledImage = styled('img')(({ theme }) => ({
  objectFit: 'cover',
  width: '100%',
  objectPosition: 'center 65%',
  borderRadius: theme.spacing(0.5),
}));

export const TitleStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  alignItems: 'center',
}));
